import { get, writable } from "svelte/store";
export var Utils;
(function (Utils) {
    /**
     * A helper array for quickly getting all valid loader type values
     *
     */
    Utils.LOADER_TYPES_ARRAY = ["circle", "dots"];
    /**
     * A helper array for quickly getting all valid position values
     *
     */
    Utils.POSITIONS_ARRAY = [
        "bottom-center",
        "bottom-left",
        "bottom-right",
        "top-center",
        "top-left",
        "top-right"
    ];
    /**
     * A helper array for quickly getting all valid "size" property values
     *
     */
    Utils.SIZES_ARRAY = ["lg", "md", "sm", "xl"];
    /**
     * A helper array for quickly getting all valid "type" property values
     *
     * TODO: Remove this and use `Variants` instead
     */
    Utils.TYPES_ARRAY = ["error", "info", "success", "warn"];
})(Utils || (Utils = {}));
export var FloatingUtils;
(function (FloatingUtils) {
    function isClickableItem(item) {
        return item.onClick !== undefined;
    }
    FloatingUtils.isClickableItem = isClickableItem;
    function isLinkItem(item) {
        return item.href !== undefined;
    }
    FloatingUtils.isLinkItem = isLinkItem;
    function isSvelteStore(items) {
        return items.subscribe !== undefined;
    }
    FloatingUtils.isSvelteStore = isSvelteStore;
    function isPromise(href) {
        return href.then !== undefined;
    }
    FloatingUtils.isPromise = isPromise;
})(FloatingUtils || (FloatingUtils = {}));
export const DEFAULT_ANIMATION_DURATION_CLASS = "duration-300";
export const getAnimationDuration = (animation) => {
    return parseInt(animation.split("-")[1]);
};
export const DEFAULT_VARIANTS = {
    default: ["bg-focused-background"],
    error: ["bg-message-error-background"],
    fourth: ["bg-app-wrapper-background"],
    info: ["bg-message-info-background"],
    plain: undefined,
    primary: undefined,
    secondary: ["bg-card-secondary-background"],
    success: ["bg-message-success-background"],
    warn: ["bg-message-warn-background"]
};
export const DEFAULT_COMPOUND_HOVER_VARIANTS = [
    { class: ["hover:bg-focused-background-hover"], disabled: false, variant: "default" },
    { class: ["hover:bg-message-error-background-hover"], disabled: false, variant: "error" },
    { class: ["hover:bg-app-wrapper-background-hover"], disabled: false, variant: "fourth" },
    { class: ["hover:bg-message-info-background-hover"], disabled: false, variant: "info" },
    { class: ["hover:bg-card-secondary-background-hover"], disabled: false, variant: "secondary" },
    { class: ["hover:bg-message-success-background-hover"], disabled: false, variant: "success" },
    { class: ["hover:bg-message-warn-background-hover"], disabled: false, variant: "warn" }
];
export const useLocalStorage = (key, defaultValue) => {
    if (typeof window === "undefined") {
        return writable(defaultValue);
    }
    const value = writable(defaultValue);
    let localValue = localStorage.getItem(key);
    if (localValue) {
        value.set(
        // TODO: Fix this
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        JSON.parse(localValue));
    }
    value.subscribe((latestValue) => {
        if (localValue === latestValue) {
            return;
        }
        localStorage.setItem(key, JSON.stringify(latestValue));
    });
    window.addEventListener("storage", () => {
        const storedValue = localStorage.getItem(key);
        if (storedValue == null) {
            return;
        }
        localValue = JSON.parse(storedValue);
        if (localValue !== get(value)) {
            value.set(localValue);
        }
    });
    return value;
};
function createCustomMessageStore() {
    const { subscribe, set, update } = writable({
        messageCount: 0,
        messagesId: []
    });
    function register(id) {
        let current;
        update((store) => {
            current = store.messagesId.length + 1;
            return {
                ...store,
                messageCount: current,
                messagesId: [...store.messagesId, id]
            };
        });
        return current;
    }
    function unregister(id) {
        update((store) => {
            if (store.messageCount <= 0) {
                console.info("No messages left to delete");
            }
            const newMessagesId = store.messagesId.filter((x) => {
                return x !== id;
            });
            const newMessageCount = newMessagesId.length;
            return {
                ...store,
                messagesId: newMessagesId,
                messageCount: newMessageCount
            };
        });
    }
    function startAutoDismiss(timeout) {
        const intervalID = setInterval(() => {
            update((store) => {
                if (store.messagesId.length <= 0) {
                    clearInterval(intervalID);
                    return store;
                }
                store.messagesId.shift();
                store.messageCount = store.messagesId.length;
                return store;
            });
        }, timeout);
        return intervalID;
    }
    return {
        subscribe,
        update,
        register,
        unregister,
        set,
        startAutoDismiss
    };
}
export const messageStore = createCustomMessageStore();
export const addDatasetProp = (node, options) => {
    if (node?.dataset) {
        node.dataset[`${options.property}`] = options.value;
        const children = node?.children;
        for (let i = 0; i < children.length; i++) {
            const el = children[i];
            el.dataset[`${options.property}`] = options.value;
            addDatasetProp(el, options);
        }
    }
    return {
        destroy() { }
    };
};
